import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent } from '../components/ui/card';

const DMCAPolicy = () => {
  const [formData, setFormData] = useState({
    ownerName: '',
    ownerEmail: '',
    ownerAddress: '',
    contentUrl: '',
    originalWork: '',
    description: '',
    signature: '',
    goodFaith: false,
    accuracy: false
  });
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = (e) => {
    e.preventDefault();
    // In production, this would send to your backend
    console.log('DMCA Takedown Request:', formData);
    setSubmitted(true);
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] text-white">
      {/* Header */}
      <header className="bg-[#1A1A1A] border-b border-gray-800 py-4">
        <div className="container mx-auto px-4">
          <Link to="/" className="text-2xl font-bold bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
            WTPL
          </Link>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-4 py-12 max-w-4xl">
        <h1 className="text-4xl font-bold mb-8 bg-gradient-to-r from-[#00D9FF] to-[#0088FF] bg-clip-text text-transparent">
          Política DMCA
        </h1>
        
        <p className="text-gray-400 mb-8">Digital Millennium Copyright Act - Procedimiento de Notificación y Eliminación</p>

        <div className="space-y-8 text-gray-300">
          <section>
            <h2 className="text-2xl font-bold text-white mb-4">1. Compromiso con los Derechos de Autor</h2>
            <p>
              WTPL ("Welcome To Planet LYO") respeta los derechos de propiedad intelectual de terceros 
              y espera que sus usuarios hagan lo mismo. De acuerdo con la Ley de Derechos de Autor 
              del Milenio Digital de 1998 ("DMCA"), responderemos rápidamente a las reclamaciones de 
              infracción de derechos de autor que se nos notifiquen adecuadamente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">2. Procedimiento de Notificación</h2>
            <p className="mb-4">
              Si usted es propietario de derechos de autor, o está autorizado para actuar en nombre 
              de uno, y cree que su obra ha sido copiada de una manera que constituye infracción de 
              derechos de autor, envíe una notificación que incluya:
            </p>
            <ol className="list-decimal list-inside space-y-2">
              <li>Una firma física o electrónica del propietario de los derechos de autor o persona autorizada</li>
              <li>Identificación de la obra protegida que se alega ha sido infringida</li>
              <li>Identificación del material que se alega infringe, con información suficiente para localizarlo</li>
              <li>Su información de contacto (dirección, teléfono, correo electrónico)</li>
              <li>Una declaración de buena fe de que el uso del material no está autorizado</li>
              <li>Una declaración de que la información en la notificación es precisa, bajo pena de perjurio</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">3. Agente Designado DMCA</h2>
            <p>
              Las notificaciones de infracción deben enviarse a nuestro Agente Designado:
            </p>
            <Card className="bg-[#1A1A1A] border-gray-700 mt-4">
              <CardContent className="p-6">
                <p className="font-bold text-white">WTPL DMCA Agent</p>
                <p>Email: <a href="mailto:planetlyo@gmail.com" className="text-cyan-400">planetlyo@gmail.com</a></p>
                <p className="mt-2 text-sm text-gray-400">
                  Tiempo de respuesta: 24-48 horas hábiles
                </p>
              </CardContent>
            </Card>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">4. Proceso de Eliminación</h2>
            <p className="mb-2">Una vez recibida una notificación válida:</p>
            <ol className="list-decimal list-inside space-y-2">
              <li>Revisaremos la notificación dentro de 24-48 horas</li>
              <li>Si es válida, eliminaremos o deshabilitaremos el acceso al contenido infractor</li>
              <li>Notificaremos al usuario que subió el contenido</li>
              <li>Mantendremos un registro de la notificación</li>
            </ol>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">5. Contra-notificación</h2>
            <p>
              Si cree que su contenido fue eliminado por error, puede enviar una contra-notificación 
              que incluya:
            </p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Su firma física o electrónica</li>
              <li>Identificación del contenido eliminado y su ubicación anterior</li>
              <li>Una declaración bajo pena de perjurio de que cree que fue un error</li>
              <li>Su nombre, dirección, teléfono</li>
              <li>Consentimiento a la jurisdicción del tribunal federal de su distrito</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-bold text-white mb-4">6. Política de Infractores Reincidentes</h2>
            <p>
              WTPL terminará las cuentas de usuarios que sean infractores reincidentes de derechos 
              de autor. Un "infractor reincidente" es un usuario que ha sido notificado de actividad 
              infractora más de dos veces.
            </p>
          </section>

          {/* DMCA Takedown Form */}
          <section className="mt-12 pt-8 border-t border-gray-700">
            <h2 className="text-2xl font-bold text-white mb-6">📋 Formulario de Notificación DMCA</h2>
            
            {submitted ? (
              <Card className="bg-green-500/10 border-green-500">
                <CardContent className="p-6">
                  <div className="flex items-center gap-3">
                    <span className="text-3xl">✅</span>
                    <div>
                      <h3 className="text-xl font-bold text-green-400">Notificación Recibida</h3>
                      <p className="text-green-300">
                        Hemos recibido su notificación DMCA. Revisaremos su solicitud y responderemos 
                        dentro de 24-48 horas hábiles.
                      </p>
                    </div>
                  </div>
                </CardContent>
              </Card>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <Card className="bg-[#1A1A1A] border-gray-700">
                  <CardContent className="p-6 space-y-4">
                    <h3 className="text-lg font-bold text-white mb-4">Información del Reclamante</h3>
                    
                    <div>
                      <label className="block text-sm font-medium mb-2">Nombre Completo *</label>
                      <Input
                        type="text"
                        required
                        value={formData.ownerName}
                        onChange={(e) => setFormData({...formData, ownerName: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="Nombre del propietario de derechos de autor"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Email *</label>
                      <Input
                        type="email"
                        required
                        value={formData.ownerEmail}
                        onChange={(e) => setFormData({...formData, ownerEmail: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="email@ejemplo.com"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Dirección</label>
                      <Input
                        type="text"
                        value={formData.ownerAddress}
                        onChange={(e) => setFormData({...formData, ownerAddress: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="Dirección física (opcional)"
                      />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-[#1A1A1A] border-gray-700">
                  <CardContent className="p-6 space-y-4">
                    <h3 className="text-lg font-bold text-white mb-4">Información del Contenido</h3>
                    
                    <div>
                      <label className="block text-sm font-medium mb-2">URL del Contenido Infractor *</label>
                      <Input
                        type="url"
                        required
                        value={formData.contentUrl}
                        onChange={(e) => setFormData({...formData, contentUrl: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="https://wtplpool.com/..."
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Obra Original Protegida *</label>
                      <Input
                        type="text"
                        required
                        value={formData.originalWork}
                        onChange={(e) => setFormData({...formData, originalWork: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="Título de la obra original"
                      />
                    </div>

                    <div>
                      <label className="block text-sm font-medium mb-2">Descripción de la Infracción *</label>
                      <textarea
                        required
                        value={formData.description}
                        onChange={(e) => setFormData({...formData, description: e.target.value})}
                        className="w-full bg-[#0A0A0A] border border-gray-600 rounded-md p-3 text-white min-h-[100px]"
                        placeholder="Describa cómo el contenido infringe sus derechos de autor..."
                      />
                    </div>
                  </CardContent>
                </Card>

                <Card className="bg-[#1A1A1A] border-gray-700">
                  <CardContent className="p-6 space-y-4">
                    <h3 className="text-lg font-bold text-white mb-4">Declaraciones Requeridas</h3>
                    
                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        required
                        checked={formData.goodFaith}
                        onChange={(e) => setFormData({...formData, goodFaith: e.target.checked})}
                        className="mt-1"
                      />
                      <span className="text-sm">
                        Creo de buena fe que el uso del material descrito no está autorizado por el 
                        propietario de los derechos de autor, su agente o la ley.
                      </span>
                    </label>

                    <label className="flex items-start gap-3 cursor-pointer">
                      <input
                        type="checkbox"
                        required
                        checked={formData.accuracy}
                        onChange={(e) => setFormData({...formData, accuracy: e.target.checked})}
                        className="mt-1"
                      />
                      <span className="text-sm">
                        La información en esta notificación es precisa, y bajo pena de perjurio, soy 
                        el propietario de los derechos de autor o estoy autorizado para actuar en nombre 
                        del propietario de un derecho exclusivo que presuntamente se ha infringido.
                      </span>
                    </label>

                    <div>
                      <label className="block text-sm font-medium mb-2">Firma Electrónica *</label>
                      <Input
                        type="text"
                        required
                        value={formData.signature}
                        onChange={(e) => setFormData({...formData, signature: e.target.value})}
                        className="bg-[#0A0A0A] border-gray-600"
                        placeholder="Escriba su nombre completo como firma"
                      />
                    </div>
                  </CardContent>
                </Card>

                <Button 
                  type="submit" 
                  className="w-full bg-gradient-to-r from-[#00D9FF] to-[#0088FF] hover:opacity-90 font-bold py-6"
                >
                  Enviar Notificación DMCA
                </Button>

                <p className="text-xs text-gray-500 text-center">
                  Advertencia: Presentar una notificación DMCA falsa puede resultar en responsabilidad 
                  legal bajo la sección 512(f) del DMCA.
                </p>
              </form>
            )}
          </section>
        </div>

        {/* Back Link */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <Link to="/" className="text-cyan-400 hover:underline">
            ← Volver al inicio
          </Link>
        </div>
      </main>
    </div>
  );
};

export default DMCAPolicy;
